import { genElObject } from "../../../../../../components/utils/HeaderElementGenerator";

// Header rows with tanggal / jam, the vehicle and the two trailer fields.
const TradoEditorHeaderTopRows = ({
  headerData,
  setHeaderData,
  headerError,
  permittedToEdit,
  isBerangkat,
  handleOnClickTrailerBerangkat,
  handleOnClickTrailerPulang,
  headerElTanggal,
  headerElJam,
  headerElVehicle,
}) => {
  const headerElTrailerBerangkat = genElObject({
    name: "Trailer Berangkat",
    field: "data_trailer_berangkat",
    value: headerData.data_trailer_berangkat
      ? `${headerData.data_trailer_berangkat.nomor}`
      : "",
    onClick: handleOnClickTrailerBerangkat,
    onClear: () => {
      setHeaderData({
        ...headerData,
        data_trailer_berangkat: null,
        trailer_berangkat_id: null,
      });
    },
    error: headerError,
    disabled: !permittedToEdit || !isBerangkat,
  });

  const headerElTrailerPulang = genElObject({
    name: "Trailer Pulang",
    field: "data_trailer_pulang",
    value: headerData.data_trailer_pulang
      ? `${headerData.data_trailer_pulang.nomor}`
      : "",
    onClick: handleOnClickTrailerPulang,
    onClear: () => {
      setHeaderData({
        ...headerData,
        data_trailer_berangkat: null,
        trailer_berangkat_id: null,
      });
    },
    error: headerError,
    disabled: !permittedToEdit || isBerangkat,
  });

  return (
    <>
      <div className="row-start-center w-full gap-3 flex-wrap sm:flex-nowrap">
        {/* on a narrow screen the jam goes under the tanggal, side by side the date gets cut off */}
        <div className="row-start-start w-full gap-3 flex-wrap sm:flex-nowrap">
          {headerElTanggal}
          {headerElJam}
        </div>
        {headerElVehicle}
      </div>
      <div className="row-start-center w-full gap-3 flex-wrap sm:flex-nowrap">
        {headerElTrailerBerangkat}
        {headerElTrailerPulang}
      </div>
    </>
  );
};

export default TradoEditorHeaderTopRows;
